import React from "react";

const PurchaseView = ({ purchase, onClose }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Purchase Details</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label fw-bold text-muted">Supplier</label>
              <p className="form-control-plaintext">{purchase.supplierName || "N/A"}</p>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold text-muted">Invoice No</label>
              <p className="form-control-plaintext">{purchase.invoiceNo || "N/A"}</p>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold text-muted">Category</label>
              <p className="form-control-plaintext">
                <span className="badge bg-secondary">{purchase.category || "N/A"}</span>
              </p>
            </div>

            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold text-muted">Buy Price</label>
                <p className="form-control-plaintext">{purchase.buyPrice || "N/A"}</p>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold text-muted">Sell Price</label>
                <p className="form-control-plaintext">{purchase.sellPrice || "N/A"}</p>
              </div>

              <div className="col-md-4 mb-3">
                <label className="form-label fw-bold text-muted">Stock</label>
                <p className="form-control-plaintext">{purchase.stock || "N/A"}</p>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold text-muted">Purchase ID</label>
              <p className="form-control-plaintext text-muted">{purchase.id}</p>
            </div>

            <hr />

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold text-muted">Created</label>
                <p className="form-control-plaintext text-muted">{formatDate(purchase.createdAt)}</p>
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-bold text-muted">Last Updated</label>
                <p className="form-control-plaintext text-muted">{formatDate(purchase.updatedAt)}</p>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseView;
